import fetchData from '@/api-client/fetcher';
import { LanguageResponse, ModuleResponse, UilmFileParams } from '../types/language.types';

const projectKey =
  import.meta.env.VITE_OS_BLOCKS_X_BLOCKS_KEY || import.meta.env.VITE_X_BLOCKS_KEY || '';

export const getUilmFile = async ({
  language,
  moduleName,
}: UilmFileParams): Promise<Record<string, string>> => {
  const params = new URLSearchParams({ Language: language, ModuleName: moduleName });
  return fetchData<Record<string, string>>(
    `/localization/v4/Key/GetUilmFile?${params.toString()}`,
    { method: 'GET' }
  );
};

export const getLanguage = async (): Promise<LanguageResponse> => {
  const params = new URLSearchParams({ ProjectKey: projectKey });
  return fetchData<LanguageResponse>(`/localization/v4/Language/Gets?${params.toString()}`, {
    method: 'GET',
  });
};

export const getModule = async (): Promise<ModuleResponse> => {
  const params = new URLSearchParams({ ProjectKey: projectKey });
  return fetchData<ModuleResponse>(`/localization/v4/Module/Gets?${params.toString()}`, {
    method: 'GET',
  });
};
